import { render } from "./Form3.vue?vue&type=template&id=45b3429d&scoped=true"
import script from "./Form3.vue?vue&type=script&lang=js"
export * from "./Form3.vue?vue&type=script&lang=js"

import "./Form3.vue?vue&type=style&index=0&id=45b3429d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-45b3429d"

export default script